import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/service/auth/auth.service';

@Component({
  selector: 'app-role-selector',
  standalone: false,
  template: `
    <div class="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6">
      <div class="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md text-center">

        <div class="mb-8">
          <h1 class="text-2xl font-bold text-gray-800">SportIQ Licence</h1>
          @if (slug) {
            <p class="mt-1 text-sm font-semibold text-blue-600 uppercase tracking-widest">{{ slug }}</p>
          }
          <p class="mt-2 text-sm text-gray-500">Choisissez votre espace de connexion</p>
        </div>

        <div class="flex flex-col gap-3">
          <button
            (click)="goTo('fed')"
            class="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 rounded-xl transition-colors text-sm"
          >
            Espace Fédération
          </button>
          <button
            (click)="goTo('club')"
            class="w-full bg-gray-700 hover:bg-gray-800 text-white font-medium py-3 rounded-xl transition-colors text-sm"
          >
            Espace Club
          </button>
        </div>

      </div>
    </div>
  `,
  styles: []
})
export class RoleSelectorComponent {
  private router = inject(Router);
  private authService = inject(AuthService);

  slug = this.authService.federationSlug?.toUpperCase() ?? '';

  goTo(role: 'fed' | 'club'): void {
    this.router.navigate([`/${role}/auth`]);
  }
}
